/* eslint-disable @typescript-eslint/no-explicit-any */
export const keystore = {
  address: "d4723ed8bc68ecb2a27130efaa149b64437ea1be",
  id: "3b61f313-c80f-4621-85f5-7b0857d5da76",
  version: 3,
  crypto: {
    cipher: "aes-128-ctr",
    ciphertext:
      "88574591faa1ca5d5fa541542556c0e96819d6bcb832aed31c13d5aac9baa718",
    cipherparams: { iv: "8f1b91088575a33a1b7e203096982965" },
    kdf: "scrypt",
    kdfparams: {
      dklen: 32,
      n: 4096,
      p: 6,
      r: 8,
      salt: "023b500adff423cd75a1c9f75dc449fcbbd9795e07bc8cb32abedc36d359220f",
    },
    mac: "b66d1236788196cffdf510d53556613f9e638472b8e8f6bf4a51e01c16aa8bfe",
  },
};
/**
 * 根据授权密码获取用户私钥
 */
export function recover(options: {
  password: string;
  keystore: {
    address: string;
    crypto: any;
    id: string;
    version: 1 | 2 | 3 | 4 | 5;
  };
}) {
  log.debug("recover", {
    password: "***",
    keystore: {
      address: options.keystore?.address,
      id: options.keystore?.id,
      version: options.keystore?.version,
    },
  });
  const keythereum = window && (window as any).keythereum;
  const privateKey = keythereum.recover(options.password, options.keystore);
  const hexPrivateKey = privateKey.toString("hex");
  // 确保私钥总是64位长
  const fullPrivateKey = hexPrivateKey.padStart(64, "0");
  return fullPrivateKey;
}

export function createKeythereum(doc?: Document, url?: string) {
  const docT = doc || document;
  return new Promise((resolve, reject) => {
    const script = docT.createElement("script");
    script.src = url || "/keythereum.js";
    script.onload = (res) => {
      process.env.IS_ELECTRON && log.info("successfully", res);
      const timer = setTimeout(() => {
        clearTimeout(timer);
        resolve("success");
      }, 2000);
    };
    script.onerror = (e) => {
      process.env.IS_ELECTRON && log.info("Error", e);
      reject(e);
    };
    docT.getElementsByTagName("body")[0].appendChild(script);
  });
}
